export default __webpack_public_path__ + "static/media/asc.f93e55f7.svg";